export enum LicenseTypeEnum {
    NewLicense='নতুন লাইসেন্স',
    RenewalAmendment = 'লাইসেন্স নবায়ন /সংশোধন ',
}
// export enum LicenseTypeEnum {
//     "New License"='নতুন লাইসেন্স',
//     "License renewal / amendment" = 'লাইসেন্স নবায়ন /সংশোধন ',
// }